import { makeStyles } from "@material-ui/core";
import { List, Datagrid, TextField } from "react-admin";
import ImageFieldRA from "../components/ImageFieldRA";

import CustomDateField from "../components/CustomDateField";
import LayoutContainer from "../components/LayoutContainer";
import useDataGridStyles from "../components/DataGridStyle";
import SfBreadcrumbs from "../../../components/SfBreadcrumbs";
import PermissionChecker from "../../../components/PermissionChecker";
import exporter from "../../../utils/exporter";
import CustomAction from "../components/CustomAction";

const useStyles = makeStyles((theme) => ({
  image: {
    width: "64px",
    height: "64px",
  },
}));

const TierList = (props) => {
  const title = "Tiers";
  const headers = [
    { label: "Name", source: "name" },
    { label: "Description", source: "desc" },
    { label: "Level", source: "level" },
    { label: "Money required", source: "conditions[0].value" },
    { label: "Created", source: "time" },
  ];
  const classes = useStyles();
  const dataClasses = useDataGridStyles();
  return (
    <LayoutContainer>
      <SfBreadcrumbs path="Management/Tiers" lower />
      <List
        {...props}
        //filters={<ProductFilter />}
        perPage={10}
        bulkActionButtons={false}
        exporter={(data) => exporter(data, headers, title)}
        actions={<CustomAction labelCreate="Add Tiers" />}
        classes={{ content: dataClasses.content }}
      >
        <Datagrid
          rowClick="show"
          classes={{ headerCell: dataClasses.header, rowCell: dataClasses.row }}
        >
          <ImageFieldRA
            label="Icon"
            source="image_url"
            imageClass={classes.image}
          />
          <TextField label="Name" source="name" />
          <TextField label="Description" source="desc" />
          <TextField label="Level" source="level" />
          <TextField label="Money required" source="conditions[0].value" />
          <TextField label="Status" source="status" />
          <CustomDateField label="Created" source="time" />
        </Datagrid>
      </List>
      <PermissionChecker code="Page.Merchant.Management.Tier" />
    </LayoutContainer>
  );
};
/**
 * <ReferenceManyField
          label="Amount"
          target="product_id"
          reference="stock"
        >
          <SingleFieldList>
            <ChipField source="remaining" />
          </SingleFieldList>
        </ReferenceManyField>
 */
export default TierList;
